import type { TFunction } from "i18next";
import { extractErrorMessage } from "@/shared/utils";
import { getSigningV2ErrorCode } from "./mapSigningV2Error";

const CANCEL_SIGNING_ERROR_KEYS: Record<string, string> = {
  document_already_signed: "signing.cancelSigning.errors.alreadySigned",
  signing_not_started: "signing.cancelSigning.errors.notStarted",
  document_not_cancelable: "signing.cancelSigning.errors.notCancelable",
  job_application_missing: "signing.cancelSigning.errors.jobApplicationMissing",
  provider_cancel_rejected: "signing.cancelSigning.errors.providerRejected",
};

export function getCancelSigningErrorMessage(error: unknown, t: TFunction): string {
  const code = getSigningV2ErrorCode(error);
  const key = code ? CANCEL_SIGNING_ERROR_KEYS[code] : undefined;
  if (key) return t(key);
  return extractErrorMessage(error, "signing.cancelSigning.errorText", t);
}
